import { inject as service } from '@ember/service';
import RESTAdapter from '@ember-data/adapter/rest';
import { resolve, reject } from 'rsvp';
import environment from '@square/environment-utils/environment';

// eslint-disable-next-line ember/no-classic-classes
export default RESTAdapter.extend({
  init(args) {
    this._super(args);
    this.useFetch = false;
  },
  store: service(),
  /**
   * Overriding the ajax call in RESTAdapter to guard 404s in sandbox
   * @param {string} url
   * @param {object} type
   * @param {object} options
   * @returns {Promise}
   */
  ajax(url, type, options) {
    const superResponse = this._super(url, type, options);
    const env = environment();
    if (!env.isSandbox) {
      return superResponse;
    }

    // will need to guard for 404s or 500s in sandbox
    return superResponse.then(resp => resolve(resp)).catch(err => {
      if (err.errors?.[0]?.status === '404' || err.errors?.[0]?.status === '500') {
        // get the model name to get the primary key of that model.
        const adapterModel = this.toString().split(':')[1];
        const modelSerializer = this.store.serializerFor(adapterModel);
        /*
         * Generate a blank model for sandbox.
         * Using '1' broke a number of tests.
         * The url should have the true key embedded as the last part of the path.
         */
        const pkValue = url.split('/').pop();
        const baseObject = {
          [modelSerializer.primaryKey]: pkValue
        };

        /*
         * the response could be expected to be burried in:
         * rootKey, collectionKey or the root object.
         */
        const returnObject = {
          ...baseObject
        };

        // Only populate rootKey property if its property is set.
        if (modelSerializer.rootKey) {
          returnObject[modelSerializer.rootKey] = baseObject;
        }

        // Only populate collectionKey property if its property is set.
        if (modelSerializer.collectionKey) {
          returnObject[modelSerializer.collectionKey] = [];
        }
        return resolve(returnObject);
      }
      return reject(err);
    });
  }
});